
export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="text-blue-100 border-t border-blue-700" style={{ backgroundColor: '#0D1B2A' }}>
      <div className="w-full px-4 sm:px-6 lg:px-8 py-8 md:py-12">
        <div className="flex flex-col md:flex-row items-start justify-between mb-8">
          {/* Adres i dane firmy po lewej */}
          <div className="flex flex-col space-y-4 mb-8 md:mb-0 md:w-1/3">
            <div className="space-y-2 text-blue-100 text-lg">
              <div>Phone: +44 7926769770</div>
              <div>Email: info@mgmreloltd.co.uk</div>
            </div>
            <div className="text-blue-100 text-sm space-y-1">
              <div className="font-semibold text-blue-100">MGM RELO LTD</div>
              <div>OFFICE 102, 268 Belsize Road, NW6 4BT, London, UK</div>
              <div>Company number: 09699504</div>
              <div>VAT number: 221 3297 39</div>
            </div>
          </div>

          {/* Logo na środku */}
          <div className="flex justify-center md:w-1/3 mb-8 md:mb-0">
            <img 
              src="https://static.readdy.ai/image/87505c603ef0feae3c12190971600621/f66559d8e1da71acba155dc2e3f39745.png"
              alt="MGM RELO Logo"
              className="h-32 md:h-40 w-auto"
            />
          </div>

          {/* Guziki funkcyjne po prawej */}
          <div className="flex flex-col space-y-4 md:w-1/3 md:items-end">
            <button
              onClick={() => scrollToSection('home')}
              className="text-blue-100 hover:text-blue-300 text-lg font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap text-left md:text-right"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-blue-100 hover:text-blue-300 text-lg font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap text-left md:text-right"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-blue-100 hover:text-blue-300 text-lg font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap text-left md:text-right"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-blue-100 hover:text-blue-300 text-lg font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap text-left md:text-right"
            >
              Contact
            </button>
          </div>
        </div>
        
        <div className="border-t border-blue-700 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-blue-100 text-sm text-center md:text-left">
              © 2025 MGM RELO LTD. All rights reserved.
            </div>
            <div className="text-blue-100/20 text-xs">
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-blue-300/30 transition-colors duration-200"
              >
                Made with Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
